import App from "./App.svelte";
import "./main.css";

const app = new App({
  target: document.body,
});

export default app;
